import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import './AdminDashboard.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';

const NAV_ITEMS = [
  { path: '/admin', label: '总览', icon: '◈', end: true },
  { path: '/admin/users', label: '用户', icon: '◉' },
  { path: '/admin/tasks', label: '任务', icon: '▸' },
  { path: '/admin/payments', label: '支付', icon: '¥' },
  { path: '/admin/system', label: '系统', icon: '⚙' },
];

function AdminDashboard() {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="ad-page">
      <header className="ad-header">
        <div className="ad-header-left">
          <button className="ad-nav-btn" onClick={() => navigate('/')}>← 首页</button>
          <span className="ad-path">
            admin<span className="ad-path-sep"> / </span>dashboard
          </span>
        </div>
        <div className="ad-header-right">
          <div className="theme-toggle" onClick={toggleTheme}>
            <div className={`theme-toggle-indicator ${theme === 'dark' ? 'theme-toggle-indicator--dark' : ''}`} />
            <span className={`theme-toggle-label theme-toggle-label--light ${theme === 'light' ? 'theme-toggle-label--active' : ''}`}>浅色</span>
            <span className={`theme-toggle-label theme-toggle-label--dark ${theme === 'dark' ? 'theme-toggle-label--active' : ''}`}>深色</span>
          </div>
          <button className="ad-nav-btn" onClick={() => navigate('/workspace')}>工作台</button>
        </div>
      </header>
      <div className="ad-body">
        <nav className="ad-sidebar">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) => `ad-sidebar-item ${isActive ? 'ad-sidebar-item--active' : ''}`}
            >
              <span className="ad-sidebar-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <main className="ad-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

// AdminRoute 守卫组件
export function AdminRoute({ children }) {
  const { user, session, loading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user || !session) {
      navigate('/auth', { replace: true });
      return;
    }

    const verify = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/admin/auth/verify`, {
          headers: { 'Authorization': `Bearer ${session.access_token}` }
        });
        if (res.ok) {
          setIsAdmin(true);
        } else {
          const errData = await res.json().catch(() => ({}));
          console.error('[AdminRoute] 验证失败:', res.status, errData);
          setIsAdmin(false);
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('[AdminRoute] 请求异常:', err);
        setIsAdmin(false);
        navigate('/', { replace: true });
      }
    };
    verify();
  }, [user, session, loading, navigate]);

  if (loading || isAdmin === null) {
    return <div className="app-loading">验证管理员权限...</div>;
  }

  return isAdmin ? children : null;
}

export default AdminDashboard;
